import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useQueryParams from 'utils/useQueryParams';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const { query } = useQueryParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, query]);

  return null;
};

export default ScrollToTop;
